import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  button: {
    borderRadius: 4,
    fontWeight: 'normal',
    height: 40,
    width: '100%',
    backgroundColor: theme.palette.colors.lightTeal,
    color: theme.palette.colors.teal,
    marginBottom: theme.spacing(2),
    '&:hover': {
      color: theme.palette.colors.white,
      backgroundColor: theme.palette.colors.teal,
    },
    [theme.breakpoints.up('mobile')]: {
      width: 'unset',
      marginRight: theme.spacing(2),
    },
  },
  selected: {
    backgroundColor: theme.palette.colors.teal,
    color: theme.palette.colors.white,
  },
}));



// WEBPACK FOOTER //
// ./src/sharedComponents/Quiz/components/SelectQuestion/useStyles.js